import { MessageSystem } from '@halo/ui-chat-react';
import { MsgItem } from '../../msg-parts';
import type { MsgExpireDurationContentProps } from './msg-expire-duration-content';
import { MsgExpireDurationContent } from './msg-expire-duration-content';

export interface MsgExpireDurationProps extends MsgExpireDurationContentProps {}

export const MsgExpireDuration = memo(function MsgExpireDuration({
  message,
}: MsgExpireDurationProps) {
  return (
    <MsgItem message={message}>
      <MessageSystem>
        <MsgExpireDurationContent message={message} />
      </MessageSystem>
    </MsgItem>
  );
});
